export function SET_FILTERS({ commit }, [favorite, progress, search, selected_areas, selected_groups, selected_tags]) {
    commit('SAVE_FILTERS', [favorite, progress, search, selected_areas, selected_groups, selected_tags])
}

export function SET_PLAYLIST({ commit }, [playlist]) {
    commit('SAVE_PLAYLIST', [playlist])
}

export function SET_ORIGIN({ commit }, [origin]) {
    commit('SAVE_ORIGIN', [origin])
}

export function SET_TRAIL_ID({ commit }, [trail_id]) {
    commit('SAVE_TRAIL_ID', [trail_id])
}

export function SET_FILTERS_SEARCH({ commit }, [search]) {
    commit('SAVE_FILTERS_SEARCH', [search])
}

export function SET_PROGRESS({ commit }, progress) {
    commit('SAVE_PROGRESS', progress)
}

export function SET_FILTER_AREA({ commit }, selected_areas) {
    commit('SAVE_FILTER_AREA', selected_areas)
}

export function SET_LOADING({ commit }, loading) {
    commit('SAVE_LOADING', loading)
}

export function SET_PODCAST_ID({ commit }, podcast_id) {
    commit('SAVE_PODCAST_ID', podcast_id)
}